import React from "react";
import { useState } from "react";
import moment from "moment";

function ProgressValueBox({ item, index }) {
  const [textShow, setTextShow] = useState(false);

  if (item.status === "COMPLETED") {
    return (
      <div className="box-main">
        {/* {index === 0 && (
          <div>
            <div className="box-circle"></div>
            <div className="box-line"></div>
          </div>
        )} */}
        <div
          className={`box ${textShow && "hover-effect"}`}
          onMouseEnter={() => setTextShow(true)}
          onMouseLeave={() => setTextShow(false)}
          key={index}
        >
          {textShow && <span className="position-change">{item.tabName}</span>}
        </div>
        {textShow && (
          <div className="datetime">
            {item?.dateTime
              ? moment(new Date(item?.dateTime))?.format("DD/MM/YYYY")
              : ""}
          </div>
        )}
      </div>
    );
  } else if (item.status === "IN_PROGRESS") {
    return (
      <div className="box-main">
        <div className="box active">
          <span>{item.tabName}</span>
        </div>
        <div className="datetime">
          {item?.dateTime
            ? moment(new Date(item?.dateTime))?.format("DD/MM/YYYY")
            : ""}
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`box pending ${textShow && "hover-effect"}`}
        onMouseEnter={() => setTextShow(true)}
        onMouseLeave={() => setTextShow(false)}
        index={index}
      >
        {textShow && <span className="position-change">{item.tabName}</span>}
      </div>
    );
  }
}

export default ProgressValueBox;
